<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 41 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.60031 20.493C4.60031 20.3338 4.6961 20.1826 4.84778 20.127C4.99945 20.0633 5.16709 20.1031 5.28683 20.2145C5.39859 20.3259 5.43053 20.5009 5.36666 20.6521C5.3028 20.8032 5.15911 20.8987 4.99146 20.8908C4.76794 20.8908 4.59232 20.7157 4.59232 20.493M4.60031 15.7192C4.60031 15.56 4.6961 15.4089 4.84778 15.3532C4.99945 15.2895 5.16709 15.3293 5.28683 15.4407C5.39859 15.5521 5.43053 15.7271 5.36666 15.8783C5.3028 16.0295 5.15911 16.1249 4.99146 16.117C4.76794 16.117 4.59232 15.9419 4.59232 15.7192M4.60031 10.9454C4.60031 10.7863 4.6961 10.6351 4.84778 10.5794C4.99945 10.5157 5.16709 10.5555 5.28683 10.6669C5.39859 10.7783 5.43053 10.9533 5.36666 11.1045C5.3028 11.2557 5.15911 11.3512 4.99146 11.3432C4.76794 11.3432 4.59232 11.1682 4.59232 10.9454M4.60031 6.1716C4.60031 6.01247 4.6961 5.8613 4.84778 5.8056C4.99945 5.74195 5.16709 5.78174 5.28683 5.89312C5.39859 6.00451 5.43053 6.17955 5.36666 6.33072C5.3028 6.48189 5.15911 6.57737 4.99146 6.56941C4.76794 6.56941 4.59232 6.39438 4.59232 6.1716M26.4336 8.10498L20.5422 4.42917C20.3027 4.278 19.9994 4.26208 19.7439 4.39733L18.0835 5.24866C17.836 5.37597 17.6683 5.62261 17.6524 5.90904C17.6364 6.18751 17.7642 6.45802 17.9957 6.61715L22.53 9.71215M16.5188 12.1866L12.6551 10.46C12.4236 10.3566 12.1522 10.3725 11.9286 10.4998L10.2123 11.4785C9.97282 11.6137 9.82114 11.8683 9.81316 12.1468C9.81316 12.4253 9.94088 12.6878 10.1804 12.839L16.0079 16.5944C16.2234 16.7376 16.4949 16.7614 16.7343 16.666L23.5997 13.9608L21.3964 19.1404C21.2607 19.4507 21.3405 19.8087 21.588 20.0394C21.8355 20.2702 22.2027 20.3179 22.498 20.1588L23.9509 19.4029C24.0787 19.3313 24.1904 19.2358 24.2702 19.1085L28.597 11.9877L33.3149 9.66442C34.3527 9.22682 34.8396 8.04133 34.4086 6.99905C33.9695 5.96473 32.78 5.4794 31.7343 5.90904L16.5188 12.1706V12.1866ZM2.59659 1H36.1249C36.1249 1 37.7215 1 37.7215 2.59126V23.2777C37.7215 23.2777 37.7215 24.8689 36.1249 24.8689H2.59659C2.59659 24.8689 1 24.8689 1 23.2777V2.59126C1 2.59126 1 1 2.59659 1Z"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <rect
      x="27.8594"
      y="14.9336"
      width="13"
      height="13"
      rx="6.5"
      fill="#539F73"
    />
    <path
      d="M34.1689 24.6877V18.1797H35.7936V24.6877H34.1689ZM32.9297 19.5474V18.1797H35.7018V19.5474H32.9297Z"
      fill="white"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 64,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
